import React, { useState } from 'react';
import Modal from 'react-modal';
import ButtonWithIcon from '../../inputs/ListWithIcon';
import Logo from '../../assets/images/ipacket_logo.png';

const SupportContactModal = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const modalStyle = {
        content: {
            width: '400px',
            height: 'auto',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Arial, sans-serif',
            padding: '0',
            boxSizing: 'border-box',
            border: 'none',
            borderRadius: '8px',
            position: 'relative',
            zIndex: 1001,
        },
    };


    const iconStyle = {
        marginRight: '10px'
    };



    return (
        <span>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={modalStyle}
                contentLabel="Support Contact"
                ariaHideApp={false}
                overlayClassName="overlay"
            >
                <div className="support-modal-header">
                    <img src={Logo} alt="iPacket Logo" className="support-modal-header-logo" />
                    <button
                        className="support-modal-header-close"
                        onClick={closeModal}
                        aria-label="Close modal"
                    >
                        ×
                    </button>
                </div>
                <div className="support-modal-body">
                    <h2>Contact Support Team</h2>
                    <a href="tel:8558939340">
                        <i className="fas fa-phone" style={iconStyle}></i>
                        855-893-9340
                    </a>
                    <a href="mailto:support@autoipacket.com" >
                        <i className="fas fa-envelope"></i>
                        support@autoipacket.com
                    </a>
                </div>
            </Modal>
            <ButtonWithIcon
                name="support-contact"
                label="Support"
                icon="fas fa-user-headset"
                onClick={openModal}
            />
        </span>
    );
};

export default SupportContactModal;
